import { AmpImage, AmpImageParams } from "types/amplience";
import { Brand } from "types/common";
import buildImageURL from "./buildImageURL";

const getImageSources = (
  image: AmpImage,
  opts: { brand: Brand } & Omit<AmpImageParams, "fmt" | "fmt.jpeg.interlaced">,
) => ({
  sources: [
    {
      type: "webp",
      srcSet: buildImageURL(image, { ...opts, fmt: "webp" }),
    },
  ],
  fallbackSource: buildImageURL(image, { ...opts, fmt: "jpg", "fmt.jpeg.interlaced": true }),
});

export default getImageSources;
